module.exports = __webpack_public_path__ + "static/q6_o-d15cf08b7ab4b6067b6d0590daa5d8c2.png";